import { ACCEPTED_POST_ATTACHMENT_TYPES } from "../../../constants/posts";

export const MIN_FOUNDED_YEAR = 1800;
export const BAND_UPCOMING_EVENT_TARGET_COUNT = 20;
export const BAND_GALLERY_PHOTO_ACCEPT = ACCEPTED_POST_ATTACHMENT_TYPES.join(",");
